import { Redirect } from 'expo-router';

export default function BusinessFeatureGate() {
  return <Redirect href="/profile" />;
}
